const isObject = (value) => typeof value === "object" && value !== null;

export default isObject;
